// extracted by mini-css-extract-plugin
export default {"container":"CloseButtonBlock_container__B7EuC","button":"CloseButtonBlock_button__KpD+U"};